import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import '../../index.scss';

const PendingBookingsTableHead = ({ venue }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          key={`p${venue.id}booking__time`}
          className="pending__booking__time__cell"
        >
          Booking Date
        </TableCell>
        <TableCell key={`p${venue.id}contact`} className="contact__cell">
          Contact Details
        </TableCell>
        <TableCell
          key={`p${venue.id}deposit`}
          className="pending__deposit__cell"
        >
          Deposit
        </TableCell>
        <TableCell
          key={`p${venue.id}actions`}
          className="pending__actions__cell"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

PendingBookingsTableHead.propTypes = {
  venue: PropTypes.object.isRequired,
};

export default PendingBookingsTableHead;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/PendingBookingsTable/PendingBookingsTableHead/index.jsx